// extracted by mini-css-extract-plugin
export default {"tabs":"AccountTabs_tabs__4Lkav","header":"AccountTabs_header__f1GUK","title":"AccountTabs_title__Zjj07","headerWrapper":"AccountTabs_headerWrapper__GGkOB"};